import * as React from 'react';
import { Form, Icon as LegacyIcon } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Input, Button, Upload, Select } from 'antd';
import { connect } from 'react-redux';
import { CURRENCIES } from '../../utils/DataConstants';
import { FormComponentProps } from '@ant-design/compatible/lib/form/Form';
import { withRouter } from 'react-router';
import { getObjectValues, nullSafeGet } from '../../utils/DataAccessUtils';
import { LocationAutocomplete } from '../location_autocomplete/LocationAutocomplete';

import { capitalize } from '../../utils/DataFormatterUtils';
import { customersRestCrudThunksForSupplier } from '../../thunks/customers_thunks';
import ClearErrors from '../clear_errors/ClearErrors';
import { CUSTOMERS_CRUD_ACTION_CREATORS } from '../../actions/customers_actions';

const FormItem = Form.Item;

interface CustomerCompanyFormProps extends FormComponentProps {
	creating: boolean;
	updating: boolean;
	history: any;
	currentUser: any;
	create: any;
	onSuccess: any;
}

class CustomerCompanyForm extends React.Component<CustomerCompanyFormProps, any> {
	handleSubmit = (e) => {
		const { create, currentUser, onSuccess } = this.props;
		e.preventDefault();
		this.props.form.validateFields((err, values) => {
			if (!err) {
				const primaryAddress = Object.keys(values)
					.filter((k) => k.indexOf('primaryAddress') > -1)
					.reduce((acc, k) => {
						const [_, x] = k.split('-');
						acc[x] = values[k];
						return acc;
					}, {});
				const buyer = {
					...values,
					displayName: values.displayName || values.name,
					primaryContactEmail: values.primaryContactEmail || currentUser.email,
					currencyId: values.currencyId || 'USD',
					primaryAddress,
					managedBySupplierCompanyId: nullSafeGet('facility.id', currentUser),
				};

				create(buyer).then((data) => onSuccess && onSuccess(data));
			}
		});
	};

	state = {
		uploadLoading: false,
		logoURL: null,
	};

	handleUploadChange = (info) => {
		if (info.file.status === 'uploading') {
			this.setState({ uploadLoading: true });
			return;
		}
		if (info.file.status === 'done') {
			const companyLogoURL = nullSafeGet('file.response.data', info);
			this.props.form.setFieldsValue({ logoURL: companyLogoURL });
			this.setState({
				logoURL: companyLogoURL,
				uploadLoading: false,
			});
		}
	};

	handleLocationAutocompleteSelect = (addr, lonLat, parsedAddress) => {
		const { form } = this.props;
		form.setFieldsValue({
			'primaryAddress-streetAddress1': parsedAddress.streetAddress1,
			'primaryAddress-city': parsedAddress.city,
			'primaryAddress-region': parsedAddress.region,
			'primaryAddress-postcode': parsedAddress.postcode,
			'primaryAddress-country': parsedAddress.country,
		});
		form.setFieldsValue({
			longitude: lonLat.lng,
			latitude: lonLat.lat,
		});
	};

	render() {
		const { creating, updating, form } = this.props;

		const submitText = 'Create customer';
		const { getFieldDecorator, setFieldsValue } = form;

		const currencyRecordsList = getObjectValues(CURRENCIES);
		const currencyRecordsMap = getObjectValues(CURRENCIES);
		getFieldDecorator(`longitude`);
		getFieldDecorator(`latitude`);
		getFieldDecorator(`primaryAddress-streetAddress1`);
		getFieldDecorator(`primaryAddress-streetAddress2`);
		getFieldDecorator(`primaryAddress-city`);
		getFieldDecorator(`primaryAddress-region`);
		getFieldDecorator(`primaryAddress-postcode`);
		getFieldDecorator(`primaryAddress-country`);
		getFieldDecorator('status', { initialValue: 'active' });
		getFieldDecorator('logoURL', {
			initialValue: null,
		});

		const isLoading = creating || updating;

		//TODO: UPGRADE FORM
		return (
			<Form layout="vertical" onSubmit={this.handleSubmit} className="CustomerCompanyForm">
				<ClearErrors actionCreators={CUSTOMERS_CRUD_ACTION_CREATORS} />
				<FormItem label="Customer name">
					{getFieldDecorator('name', {
						rules: [{ required: true, message: "Please input your customer's legal entity name!" }],
					})(<Input style={{ maxWidth: 500 }} />)}
				</FormItem>
				<FormItem label="Primary Contact Email Address">
					{getFieldDecorator('primaryContactEmail', {
						rules: [
							{ required: true, message: "Please input customer's primary contact's email!" },
							{ type: 'email', message: 'This is not a valid email!' },
						],
					})(<Input placeholder="John.Doe@customer.com" />)}
				</FormItem>
				<Form.Item label="Currency">
					{form.getFieldDecorator('currencyId', {
						rules: [{ required: true, message: 'Please select a currency for this event.' }],
						initialValue: 'USD',
					})(
						<Select
							showSearch={true}
							style={{ width: 300 }}
							optionFilterProp="children"
							filterOption={(input, option) =>
								currencyRecordsMap[option.props.value].displayNamePlural
									.toLowerCase()
									.indexOf(input.toLowerCase()) >= 0
							}
							placeholder="Currency"
						>
							{currencyRecordsList.map((currency) => (
								<Select.Option key={currency.id} value={currency.id}>
									{capitalize(currency.displayNamePlural)} ({currency.id})
								</Select.Option>
							))}
						</Select>
					)}
				</Form.Item>
				<Form.Item label="Primary Address">
					<LocationAutocomplete
						initialValue={''}
						placeholder="Where is your customers\'s primary location?"
						onSelect={this.handleLocationAutocompleteSelect}
					/>
				</Form.Item>
				<FormItem>
					<Button
						type="primary"
						htmlType="submit"
						loading={isLoading}
						className="supplierForm__button"
					>
						{submitText}
					</Button>
				</FormItem>
			</Form>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	history: ownProps.history,

	currentUser: state.session.currentUser,
	creating: state.customers.creating,
	updating: state.customers.updating,
});

const mapDispatchToProps = (dispatch) => ({
	create: (entity) => dispatch(customersRestCrudThunksForSupplier.create(entity)),
});

export default withRouter<any, any>(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(Form.create<CustomerCompanyFormProps>()(CustomerCompanyForm))
);
